<template>
  <section class="list--container--dashboards">
    <b-card body-class="card-body--container">
      <h1 class="container--title">Bienvenidos al catálogo de Dashboards de Envíame</h1>
      <div class="list-cards-container">
        <card
          v-for="(card, index) in dashboards"
          :key="index"
          :card="card"
          :maxHeight="maxCardNameHeight"
          @cardDataHeight="calcHeight"
        ></card>
      </div>
    </b-card>
  </section>
</template>
<script>
import BaseServices from '@/store/services/index'
import card from '@/views/modules/dashboards-list/components/card.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    card
  },
  data() {
    return {
      baseService: new BaseServices(this),
      dashboards: [],
      cardHeights: {},
      maxCardNameHeight: null
    }
  },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    }
  },
  mounted() {
    this.getData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    async getData() {
      document.getElementById('loading-bg').style.display = 'block'
      return await this.baseService.callService('getDashboards', {}, {})
        .then(response => {
          this.dashboards = response?.data && response?.data.length > 0 ? [...response?.data] : []
          this.cardHeights = {}
          this.maxCardNameHeight = null
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          document.getElementById('loading-bg').style.display = 'none'
        })
    },
    calcHeight({height, id}) {
      this.$set(this.cardHeights, id, height)
      if (Object.keys(this.cardHeights).length === this.dashboards.length) {
        const maxHeight = Math.max(...Object.values(this.cardHeights))
        this.maxCardNameHeight = maxHeight
        this.cardHeights = {}
      }
    },
    handleResize() {
      this.maxCardNameHeight = null
      this.cardHeights = {}
    }
  }
}
</script>
<style lang="scss">
  .list--container--dashboards {

    .list-cards-container {
      padding: 45px;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 40px;
      justify-items: stretch;
    }
    .container--title {
      font-family: Montserrat;
      font-weight: 500;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0;
      color: #7C7A89;
    }
    .card-body--container {
      padding: 30px;
    }
  }
</style>